import apiClient, { USE_MOCK } from '@shared/api/client';
import { ENDPOINTS } from '@shared/api/endpoints';
import { mockQrcodeData } from './mockQrcodeData';

// 根據 USE_MOCK 設定決定使用真實 API 或 Mock 資料
// 模擬網路延遲
const delay = (ms = 500) => new Promise(resolve => setTimeout(resolve, ms));

/*
x 52 activity004 System
x 56 activity008 System, Admin, Root, Monastery
*/

/*
用戶產生qrcode頁面
54 activity003 Member, Viewer
*/
export const get54QrcodeUserCode = async (
  official_code
  ) => {
  if (USE_MOCK) {
    await delay(300);
    return {
      data: mockQrcodeData.i54UserCode
  }}

  return apiClient.get(ENDPOINTS.QRCODE.i54_USER_CODE);
};

/*
用戶開掃描器，掃描活動qrcode頁面
55 activity004 Member, Viewer
 */
export const post55QrcodeUserCheckin = async (
  target_code
  ) => {
  if (USE_MOCK) {
    await delay(300);
    return {
      data: mockQrcodeData.i55UserCheckin(
        target_code
  )}}

  return apiClient.post(ENDPOINTS.QRCODE.i55_USER_CKECKIN, { target_code });
};


/*
跳出「報到成功 or 轉點成功」提醒
95 activity007 Member, Viewer
 */
export const get95QrcodeUserCheck = async (
) => {
  if (USE_MOCK) {
  // if(1) {
    await delay(300);
    return {
      data: mockQrcodeData.i95UserCheck(false
  )}}
  return apiClient.get(ENDPOINTS.QRCODE.i95_USER_CHECK);
};

//---------------------------------------------------------------------------
const apiQrcode = {
  get54UserCode: get54QrcodeUserCode,
  post55UserCheckin: post55QrcodeUserCheckin,
  get95UserCheck: get95QrcodeUserCheck,
}
export default apiQrcode;
